// Shared helpers for the warehouse report (Raport-kogajard).
//
// The table and its footer must agree on which rows are visible and how a
// row is valued, otherwise the footer total drifts from the column it is
// supposed to sum. Keep both reading from here.

// Same name/code search the table has always applied: name wins over code,
// both are prefix matches, and an empty search shows everything.
export const filterKogaRows = (rows, name, code) =>
  (rows || []).filter((row) => {
    if (name && name !== "") {
      return String(row.nameofproduct || "")
        .toLowerCase()
        .startsWith(name.toLowerCase());
    }
    if (code && code !== "") {
      return String(row.code || "").startsWith(code);
    }
    return true;
  });

// Stock value of one row in $: remaining cartons × dozens per carton × buy price.
export const rowMoney = (row) =>
  Number(row.rasidKarton) * Number(row.numberOfDarzan) * Number(row.price);

// Footer totals for a set of rows. Non-numeric fields count as 0 so one
// broken product can't turn the whole footer into NaN.
export const sumKogaRows = (rows) => {
  let cartons = 0;
  let money = 0;
  for (const row of rows || []) {
    const c = Number(row.rasidKarton);
    const m = rowMoney(row);
    if (Number.isFinite(c)) cartons += c;
    if (Number.isFinite(m)) money += m;
  }
  return {
    cartons: Number(cartons.toFixed(2)),
    money: Number(money.toFixed(2))
  };
};
